export const FLAG_MIXPANEL_REPLAYS = 'mixpanel-session-replays';
export const FLAG_SIMPLIFIED_ACLS = 'simplified-acls';
export const FLAG_INVITE_DURING_ONBOARDING = 'invite-during-onboarding';
export const FLAG_INVITE_BY_LINK = 'invite-by-link';
export const FLAG_AI_CREDITS = 'ai-credits';
export const FLAG_ADMIN_INSIGHTS = 'admin-insights';
export const FLAG_COLLECTION_INFO_TOTAL_PROXY_SIZE =
  'collection-info-total-proxy-size';
export const FLAG_SEARCH_INFINITE_SCROLL = 'search-infinite-scroll';
